<template>
  <div class="form-group">
    <label>{{ question.statement }}</label>
    <p class="text-red" v-if="m_error">{{ m_error }}</p>
    <div class="row">
      <div class="col-xs-12">
        <div class="box box-solid box-primary">
          <div class="box-body">
            <component
              v-for="field in question.fields"
              v-bind:key="field.uuid"
              ref="fields"
              v-on:fieldUpdated="onFieldUpdated"
              :is="getFieldComponent(field)"
              :field="field"
              :fieldAnswer="getFieldAnswer(field)"
              :isDisabled="disabledAttribute"
            >
            </component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CNPJField from './fields/CNPJField'
import StringField from './fields/StringField'
import YearField from './fields/YearField'
import EmailField from './fields/EmailField'
import PhoneNumberField from './fields/PhoneNumberField'
import MultipleChoiceField from './fields/MultipleChoiceField'
import IntegerField from './fields/IntegerField'

export default {
  name: 'FormQuestion',
  props: ['question', 'answer', 'isDisabled'],
  data () {
    return {
      m_question: this.question,
      m_answer: {
        questionUuid: this.question.uuid,
        value: {
          fieldsAnswers: this.answer.value && this.answer.value.fieldsAnswers ? this.answer.value.fieldsAnswers : []
        }
      },
      m_error: null,
      componentsPerType: {
        'cnpj': CNPJField,
        'string': StringField,
        'year': YearField,
        'email': EmailField,
        'phone_number': PhoneNumberField,
        'multiple-choice': MultipleChoiceField,
        'integer': IntegerField
      }
    }
  },
  computed: {
    disabledAttribute () {
      return this.question.disabled === true || this.isDisabled === true
    }
  },
  watch: {
    'm_answer.value': {
      handler () {
        this.$emit('answerUpdated', { 'questionUuid': this.question.uuid, 'value': this.m_answer.value })
      },
      deep: true
    }
  },
  mounted () {
    this.question = this.sortQuestionFieldsByRenderingOrder(this.question)
  },
  methods: {
    sortQuestionFieldsByRenderingOrder (question) {
      question.fields.sort(function (a, b) {
        return a.renderingOrder - b.renderingOrder
      })
      return question
    },
    getFieldComponent (f) {
      return this.componentsPerType[f.type]
    },
    onFieldUpdated (rowIndex, newFieldAnswer) {
      for (let i in this.m_answer.value.fieldsAnswers) {
        if (this.m_answer.value.fieldsAnswers[i].fieldUuid === newFieldAnswer.fieldUuid) {
          this.m_answer.value.fieldsAnswers[i] = newFieldAnswer
          return
        }
      }

      this.m_answer.value.fieldsAnswers.push({ fieldUuid: newFieldAnswer.fieldUuid, value: newFieldAnswer.value })
    },
    getFieldAnswer (field) {
      for (let i in this.m_answer.value.fieldsAnswers) {
        if (this.m_answer.value.fieldsAnswers[i].fieldUuid === field.uuid) {
          return { fieldUuid: this.m_answer.value.fieldsAnswers[i].fieldUuid, value: this.m_answer.value.fieldsAnswers[i].value }
        }
      }

      return { fieldUuid: field.uuid, value: null }
    },
    isValid () {
      this.m_error = null

      let areFieldAnswersBlank = true
      for (let field in this.m_answer.value.fieldsAnswers) {
        if (this.m_answer.value.fieldsAnswers[field].value) {
          areFieldAnswersBlank = false
        }
      }
      if (!this.question.required && areFieldAnswersBlank) {
        this.m_answer.value.fieldsAnswers = []
        return true
      }

      if (!this.$refs.fields) {
        return true
      }

      let areFieldAnswersValid = true
      this.$refs.fields.forEach(f => {
        if (!f.isValid()) {
          areFieldAnswersValid = false
        }
      })

      return areFieldAnswersValid
    }
  }
}
</script>



// WEBPACK FOOTER //
// FormQuestion.vue?2e6ba2f8